/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface AssetStopEventMarker {
  width?: number,
  height?: number,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic for stop(destination) of the trip
 *
 * ```typescript
 *  import {getAssetStopEventMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getAssetStopEventMarker({fillColor, width, height}),
 *    width  : width,
 *    height : height
 * }
 * ```
 */
export const getAssetStopEventMarker = ({
  fillColor = dlsColor('grey4'),
  width = 18,
  height = 25
}: AssetStopEventMarker) => {
  const svg = (`
    <svg width='${width}' height='${height}' viewBox='0 0 18 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M9 21.4995L8.22322 22.1293L9 23.0874L9.77678 22.1293L9 21.4995ZM9 21.4995C9.77678 22.1293 9.77687 22.1292 9.77699 22.129L9.77737 22.1286L9.7786 22.127L9.78294 22.1217L9.79907 22.1017L9.85993 22.0257C9.91279 21.9596 9.98967 21.8628 10.0871 21.7387C10.282 21.4907 10.5595 21.1331 10.892 20.6923C11.5564 19.8117 12.4441 18.5944 13.3337 17.2515C14.2209 15.9122 15.1226 14.4292 15.806 13.02C16.4721 11.6466 17 10.2076 17 8.99951C17 4.58123 13.4183 0.999512 9 0.999512C4.58172 0.999512 1 4.58123 1 8.99951C1 10.2076 1.52788 11.6466 2.19399 13.02C2.87745 14.4292 3.77908 15.9122 4.66633 17.2515C5.55589 18.5944 6.4436 19.8117 7.10796 20.6923C7.4405 21.1331 7.71796 21.4907 7.91286 21.7387C8.01033 21.8628 8.08721 21.9596 8.14007 22.0257L8.20093 22.1017L8.21706 22.1217L8.2214 22.127L8.22263 22.1286L8.22301 22.129C8.22313 22.1292 8.22322 22.1293 9 21.4995Z' fill='${fillColor}' stroke='white' stroke-width='2'/>
      <circle cx='9' cy='8.99951' r='4.5' fill='white' stroke='${fillColor}' stroke-width='3'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getAssetStopEventMarker;
